// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".schedule-list-item__detail{margin-right:24px}.schedule-list-item--is-hover .schedule-list-item__detail:not(:last-child){margin-right:8px}.schedule-list-item__detail:not(:last-child){margin-right:36px}.schedule-list-item__detail__name{display:inline-block;min-width:0;max-width:17ch;overflow:hidden;text-overflow:ellipsis}", ""]);
// Exports
module.exports = exports;
